import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import styles from "../../../styles/common-styles.module.css";
import { SmallItemImage } from "../ItemImage/SmallItemImage";

interface ItemTaskCardProps {
  item: Item;
}

export const ItemTaskCard = ({ item }: ItemTaskCardProps) => {
  return (
    <ItemCard>
      <div className={styles["item-card-root-row"]}>
        <SmallItemImage imageUrl={item.imageUrl || item.smallImageUrl || ""} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          <ItemDescription description={item.noFormatted || ""} />
          <ItemDescription description={item.description || ""} />
        </div>
      </div>
    </ItemCard>
  );
};
